import { motion } from "framer-motion";
import { SectionLabel, Reveal } from "./Section";

export const Experience = ({ t }) => {
  return (
    <section id="experience" className="relative py-28 md:py-40 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <SectionLabel num={t.experience.num} label={t.experience.label} id="experience" />

        <Reveal>
          <h2 className="font-display font-bold tracking-tight text-3xl md:text-5xl mb-16 max-w-xl">
            {t.experience.title}
          </h2>
        </Reveal>

        <div className="group/list">
          {t.experience.items.map((item, i) => (
            <motion.div
              key={item.company}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`experience-${item.company.toLowerCase().replace(/\s/g, "-")}`}
              className="group relative border-l-2 border-[#1a1d27] pl-6 md:pl-10 pb-14 last:pb-0 hover:border-[#2563eb] transition-colors duration-500 md:group-hover/list:opacity-40 md:hover:!opacity-100"
            >
              <span className="absolute -left-[7px] top-1.5 w-3 h-3 rounded-full bg-[#1a1d27] group-hover:bg-[#2563eb] group-hover:scale-125 transition-all duration-300" />

              <div className="grid md:grid-cols-12 gap-3 md:gap-8 items-baseline">
                <div className="md:col-span-3">
                  <span className="font-mono text-sm text-[#2563eb]">{item.period}</span>
                </div>

                <div className="md:col-span-9">
                  <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 mb-3">
                    <h3 className="font-display font-bold text-2xl md:text-3xl text-white">{item.role}</h3>
                    <span className="text-[#8b95a5]">@</span>
                    <span className="font-display font-bold text-2xl md:text-3xl text-[#2563eb]">{item.company}</span>
                  </div>
                  <p className="text-[#8b95a5] leading-relaxed max-w-2xl mb-5">{item.desc}</p>
                  <div className="flex flex-wrap gap-2">
                    {item.stack.map((s) => (
                      <span
                        key={s}
                        className="font-mono text-[11px] px-3 py-1 rounded-full border border-[#1a1d27] text-[#8b95a5] group-hover:border-[#2563eb]/40 group-hover:text-white transition-colors duration-300"
                      >
                        {s}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
